// Las cadenas con las que trabaja Promos venta: varias para el admin de tenant, ninguna si opera una.
import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useReferralRetailers } from '@/domains/credit/promotions/api/useReferralRetailers';
import { choosesRetailers } from './promotionsRetailerMode';

export function usePromotionsRetailers() {
    const { roleAssignments } = useAuth();
    const multi = useMemo(() => choosesRetailers(roleAssignments), [roleAssignments]);
    const retailers = useReferralRetailers(multi);
    const retailerIds = useMemo(
        () => (retailers.data ?? []).map((retailer) => retailer.retailerId),
        [retailers.data],
    );
    const retailerNames = useMemo(
        () => new Map((retailers.data ?? []).map((one) => [one.retailerId, one.name])),
        [retailers.data],
    );
    const options = useMemo(
        () =>
            [...(retailers.data ?? [])]
                .sort((a, b) => a.name.localeCompare(b.name, 'es-MX'))
                .map((retailer) => ({ value: retailer.retailerId, label: retailer.name })),
        [retailers.data],
    );
    return {
        multi,
        retailers: retailers.data,
        loading: retailers.isLoading,
        error: retailers.error,
        refetch: retailers.refetch,
        retailerIds,
        retailerNames,
        options,
        nameOf: (retailerId: string) => retailerNames.get(retailerId) ?? retailerId,
    };
}
